import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import './style.scss';
import { getNameInitials } from '../../../../shared/services/Utility';
import { save_accepted_challenge_data } from '../../../../redux/actions/DashBoardActions';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';
import {
  gotoSimulatedTest,
  updateChallengeStatus,
} from '../../../../redux/actions';

const ChallengeList = ({
  sessionToken,
  userId,
  loading,
  data = [],
  send_or_recieve,
  challengeSentTo = () => {
  },
  userName,
  acceptBtn = false,
  save_accepted_challenge_data = () => {
  },
  gotoSimulatedTest = () => {
  },
  history,
  enqueueSnackbar,
  updateChallengeStatus,
  fallbackText = 'No user found.',
}) => {
  const onAcceptBtn = (opponent_userId, challenge_id, opponents_scores) => {
    const data = {
      opponent_userId: opponent_userId,
      challenge_id: challenge_id,
      opponents_scores: opponents_scores,
    };
    save_accepted_challenge_data(data);
    updateChallengeStatus(true);

    // /* change screen */
    const questionBody = {
      userId,
      sessionToken,
    };
    gotoSimulatedTest(questionBody, (message, type) => {
      if (type === 'success') {
        history.push(ROUTE_CONSTANTS.SIMULATDED_TESTS_QUESTIONS);
      } else {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    });

    //history.push(ROUTE_CONSTANTS.SIMULATDED_TESTS_QUESTIONS);
  };

  data.length &&
  data.sort((a, b) =>
    a.userName.toLowerCase().localeCompare(b.userName.toLowerCase()),
  );
  return data.length ? (
    data.length === 1 && data[0].userName === userName ? (
      <span className='fallback-text'>{fallbackText}</span>
    ) : (
      <div className='card_hist'>
        <ul>
          {data.map((itm, index) => {
            return (
              <li key={index}>
                <div className='d-flex align-items-center card_history challenge-wrapper'>
                  <div className='name-container'>
                    <span>
                      {itm.userName &&
                        itm.userName !== '' &&
                        itm.userName.length > 0 &&
                        getNameInitials(itm.userName).toUpperCase()}
                    </span>
                    <h6>{itm.userName}</h6>
                  </div>
                  <div className='button-container'>

                    {!acceptBtn ? (
                      <button
                        className='green-btn'
                        type='button'
                        onClick={() => challengeSentTo(itm.userId)}
                      >
                        Challenge
                      </button>
                    ) : (
                      <button
                        className='green-btn'
                        style={{ backgroundColor: '#1b3665' }}
                        type='button'
                        onClick={() =>
                          onAcceptBtn(
                            itm.userId,
                            itm.challenge_id,
                            itm.test_score,
                          )
                        }
                      >
                        Accept
                      </button>
                    )}

                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    )
  ) : (
    <span className='fallback-text'>{fallbackText}</span>
  );
};

const mapStateToProps = (state) => {
  return {
    sessionToken: state.CommonReducer.sessionToken,
    userId: state.CommonReducer.userId,
    loading: state.LoadingReducer.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    save_accepted_challenge_data: (params) =>
      dispatch(save_accepted_challenge_data(params)),
    gotoSimulatedTest: (params, callback) =>
      dispatch(gotoSimulatedTest(params, callback)),
    updateChallengeStatus: (value) => dispatch(updateChallengeStatus(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(withRouter(ChallengeList)));
